//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SimpleButtonGroup',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: false},
  },
  computed: {
    showControl() {
      return this.control.Options[0].value !== "0";
    }
  },
  methods: {
    stoneNumberChanged(v) {
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value: v,
      })
    },
  },
}
